// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"f3387438","179":"6f1c7b66","236":"0b48f720","303":"b51e7fcc","369":"b51e7fcc","566":"b51e7fcc","606":"665415b7","848":"e3f90e3f"}[chunkId] + ".chunk.css";
};